import { VisitDiagnosis } from '@dreryk/egabinet-visit-frontend-api';
import { Disease } from '@dreryk/medical-dictionaries-api';

import { FieldControllerProps } from '@dreryk/react-common';

import { DiagnosisSelector } from '../../../../common/diagnosisSelector/DiagnosisSelector';
import { medicalDevicesTranslationKeys } from '../../translations';

type DiagnosisFieldProps = FieldControllerProps<'disease', Disease | null> & {
   readonly diagnosis?: VisitDiagnosis[];
};

export const DiagnosisField = (props: DiagnosisFieldProps): JSX.Element => {
   return (
      <DiagnosisSelector
         name={'disease'}
         register={props.register}
         diagnoses={props.diagnosis}
         label={medicalDevicesTranslationKeys.fields.diagnosis}
         required
      />
   );
};
